<div *ngIf="!typeSelected" [class.bounce-out]="animateClass !== null" class="col-12">
  <h5 class="fs-18 my-5 text-center">{{'t-developments.t-development-choice' | translate}}</h5>
  <div class="choices d-flex align-items-center justify-content-center h-auto gap-5">
    <div *ngFor="let type of developmentTypes" (click)="selectType(type)" [ngbTooltip]="type.tooltip"
      class="align-items-center border card d-flex flex-column gap-3 justify-content-center p-3 rounded-3 cursor-pointer">
      <img src="{{type.img}}" width="120">
      <div class="choice-texts">
        <h5>{{type.text}}</h5>
      </div>
    </div>
  </div>
</div>

<div class="col-12" *ngIf="typeSelected">
  <div *ngIf="typeSelected.id == 1">
    <div class="align-items-center d-flex justify-content-between">
      <div class="align-items-center col-md-6 d-flex">
        <div
          *ngIf="(loginUser.id===propertyUpdate?.mainAgent) || permissionsService.canEditProperty(loginUser, propertyToPermission?.store?.id) || !propertyUpdate"
          (click)="typeSelected = null"
          class="align-items-center cursor-pointer badge badge-soft-info choice-selected d-flex gap-3 justify-content-center px-4 py-2">
          <img src="{{typeSelected.img}}" width="40">
          <h5 class="fs-14 mb-0">{{typeSelected.text}}</h5>
        </div>
        <div class="col-md-6 ms-3">
          <div class="search-box">
            <input type="text" name="searchTerm" class="form-control"
              [attr.placeholder]="('t-search-for'|translate) + ' ' +('t-title'|translate|lowercase) +', ' +('t-reference'|translate|lowercase) +'...'"
              [formControl]="queryField">
            <i class="ri-search-line search-icon"></i>
          </div>
        </div>
      </div>
      <button
        *ngIf="(loginUser.id===propertyUpdate?.mainAgent) || permissionsService.canEditProperty(loginUser, propertyToPermission?.store?.id) || !propertyUpdate"
        (click)="addFraction(fractionContent)"
        class="btn btn-outline-primary float-end waves-effect waves-primary btn-sm">
        <i class="ri-add-fill me-1 align-bottom"></i>
        {{'t-developments.t-new-fraction' | translate}}
      </button>
    </div>
    <div class="units mt-3">
      <ngx-simplebar class="mx-n4 px-4" style="max-height: calc(100vh - 340px);">
        <div class="table-card gridjs-border-none mt-0">
          <div class="table-responsive overflow-visible"
            *ngIf="dataFractions && dataFractions.length>0 && unitsToShow?.length > 0">

            <table class="table align-middle">
              <thead>
                <tr class="bg-light text-muted sticky-table">
                  <th scope="col" class="cursor-pointer" (click)="onUnitsSort('reference')">
                    {{ 't-m-properties.t-property'| translate }}
                    <span class="ms-1">{{ getUnitsSortIndicator('reference') }}</span>
                  </th>
                  <!-- <th scope="col">{{ 't-m-properties.t-reference'| translate }}</th> -->
                  <th scope="col" class="cursor-pointer" (click)="onUnitsSort('floor')">
                    {{ 't-m-properties.t-floor'| translate }}
                    <span class="ms-1">{{ getUnitsSortIndicator('floor') }}</span>
                  </th>
                  <!-- <th scope="col">Fração</th> -->
                  <th scope="col">{{ 't-m-properties.t-property-type'| translate }}
                  </th>
                  <th scope="col" class="cursor-pointer" (click)="onUnitsSort('price')">
                    {{ 't-m-properties.t-price'| translate }}
                    <span class="ms-1">{{ getUnitsSortIndicator('price') }}</span>
                  </th>
                  <th scope="col" class="align-middle cursor-pointer" (click)="onUnitsSort('grossArea')">
                    <i class="fs-18 las la-ruler-combined"></i>
                    <span class="ms-1">{{ getUnitsSortIndicator('grossArea') }}</span>
                  </th>
                  <th scope="col" class="align-middle cursor-pointer" (click)="onUnitsSort('bedrooms')">
                    <i class="fs-18 la-bed las"></i>
                    <span class="ms-1">{{ getUnitsSortIndicator('bedrooms') }}</span>
                  </th>
                  <th scope="col" class="align-middle cursor-pointer" (click)="onUnitsSort('bathrooms')">
                    <i class="fs-18 las la-bath"></i>
                    <span class="ms-1">{{ getUnitsSortIndicator('bathrooms') }}</span>
                  </th>
                  <th scope="col">{{ 't-m-properties.t-status'| translate }}</th>
                  <th scope="col">{{'t-action' | translate}}</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let property of unitsToShow">
                  <td>
                    <span>
                      <div class="d-flex align-items-center">
                        <div class="flex-grow-1">
                          <span class="fs-13 mb-1">
                            {{property.title[0].text}}
                          </span>
                          <p *ngIf="property?.reference && !property?.isNew" class="mb-0">
                            {{ 't-m-properties.t-reference'| translate }} :
                            <span class="fs-12">
                              {{property.reference}}
                            </span>
                          </p>
                        </div>
                      </div>
                    </span>
                  </td>
                  <!-- <td (click)="openModal(property)" class="cursor-pointer">{{property.reference}}</td> -->
                  <!-- Piso, tipo, preço, área, quartos e WC: células editáveis com um clique -->
                  <ng-container *ngTemplateOutlet="inlineCells; context: { unit: property }"></ng-container>
                  <td class="status">
                    <span class="badge text-uppercase" [class.cursor-pointer]="canToggleFractionStatus(property)"
                      [ngbTooltip]="canToggleFractionStatus(property) ? ((property?.status ? 't-m-properties.t-inactive' : 't-m-properties.t-active') | translate) : null"
                      container="body" placement="top" (click)="toggleFractionStatus(property)"
                      [ngClass]="{'badge-soft-success':property?.status && !property?.isNew ,'badge-soft-danger':!property?.status && !property?.isNew, 'badge-soft-info': property?.isNew}">
                      <!-- {{property?.status?'Active':'Inactive'}} -->
                      <ng-container *ngIf="property?.status && !property?.isNew">
                        {{ 't-m-properties.t-active'| translate }}
                      </ng-container>
                      <ng-container *ngIf="!property?.status && !property?.isNew">
                        {{ 't-m-properties.t-inactive'| translate }}
                      </ng-container>
                      <ng-container *ngIf="property?.isNew">
                        {{ 't-new'| translate }}
                      </ng-container>
                    </span>
                  </td>
                  <td>
                    <ul class="list-inline hstack gap-2 mb-0">
                      <li
                        *ngIf="canManageUnit(property)"
                        ngbTooltip="{{'t-edit' | translate}}" container="body" placement="top" class="list-inline-item">
                        <a (click)="editFraction(property, fractionContent)"
                          class="edit-item-btn text-primary cursor-pointer"><i
                            class="ri-pencil-fill align-bottom  fs-16"></i></a>
                      </li>
                      <ng-container *appHasPermission="'CREATE_PROPERTIES'">
                        <li *ngIf="canManageUnit(property)" ngbTooltip="{{'t-duplicate' | translate}}" container="body"
                          placement="top" class="list-inline-item">
                          <a (click)="duplicateFraction(property, null)"
                            class="edit-item-btn cursor-pointer text-secondary">
                            <i class="align-bottom fs-16"
                              [ngClass]="property?.isDuplicating ? 'ri-loader-4-line spin' : 'ri-file-copy-line'"></i>
                          </a>
                        </li>
                        <!-- "Criar revenda": imóvel comum a partir da fração (só gravadas). -->
                        <li *ngIf="canManageUnit(property) && !property.isNew" ngbTooltip="{{'t-create-resale' | translate}}"
                          container="body" placement="top" class="list-inline-item">
                          <a (click)="createResale(property)"
                            class="edit-item-btn cursor-pointer text-secondary">
                            <i class="align-bottom fs-16"
                              [ngClass]="property?.isCreatingResale ? 'ri-loader-4-line spin' : 'ri-exchange-line'"></i>
                          </a>
                        </li>
                      </ng-container>
                      <li class="list-inline-item" ngbTooltip="{{'t-view' | translate}}" placement="top"
                        container="body"
                        *ngIf="(loginUser.id!==propertyUpdate?.mainAgent && loginUser.id!==property?.mainAgent) && !permissionsService.canEditProperty(loginUser, propertyToPermission?.store?.id)">
                        <a class="edit-item-btn cursor-pointer text-primary" (click)="viewFraction(property)"><i
                            class="ri-eye-line align-bottom  fs-16"></i></a>
                      </li>
                      <ng-container>
                        <li
                          *ngIf="permissionsService.canDeleteProperty(loginUser, propertyToPermission?.store?.id) || !propertyUpdate"
                          ngbTooltip="{{'t-delete' | translate}}" container="body" placement="top"
                          class="list-inline-item">
                          <a (click)="deleteFraction(property, null)"
                            class="remove-item-btn cursor-pointer text-danger">
                            <i class="ri-delete-bin-fill align-bottom"></i>
                          </a>
                        </li>
                      </ng-container>
                    </ul>
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="mb-4 me-0 mt-0 row" *ngIf="dataFractions && dataFractions!.length>0">
              <!-- Pagination -->
              <div class="col">
                <div class="listjs-pagination">
                  <ngb-pagination [maxSize]="4"
                    [collectionSize]="queryField.value ? unitsToShow?.length : (dataFractions.length)" [(page)]="page"
                    [pageSize]="pageSize"
                    (pageChange)="refreshPagination(queryField.value ? unitsToShow : dataFractions)">
                  </ngb-pagination>
                </div>
              </div>
              <!-- End Pagination -->
            </div>
          </div>
          <div *ngIf="!dataFractions || dataFractions.length === 0  || unitsToShow?.length == 0">
            <div class="py-4 text-center">
              <div>
                <lord-icon src="https://cdn.lordicon.com/msoeawqm.json" trigger="loop"
                  colors="primary:#405189,secondary:#0ab39c" style="width:72px;height:72px">
                </lord-icon>
              </div>
              <div class="mt-4">
                <h5>{{'t-developments.t-no-one-unit' | translate}}</h5>
              </div>
            </div>
          </div>
        </div>
      </ngx-simplebar>
    </div>
  </div>
  <div *ngIf="typeSelected.id == 2">
    <div class="align-items-center d-flex justify-content-between">
      <div class="align-items-center col-md-6 d-flex">
        <div
          *ngIf="(loginUser.id===propertyUpdate?.mainAgent) || permissionsService.canEditProperty(loginUser, propertyToPermission?.store?.id) || !propertyUpdate"
          (click)="typeSelected = null"
          class="align-items-center cursor-pointer badge badge-soft-info choice-selected d-flex gap-3 justify-content-center px-4 py-2">
          <img src="{{typeSelected.img}}" width="40">
          <h5 class="fs-14 mb-0">{{typeSelected.text}}</h5>
        </div>
        <div class="col-md-6 ms-3">
          <div class="search-box">
            <input type="text" name="searchTerm" class="form-control"
              [attr.placeholder]="('t-search-for'|translate) + ' ' +('t-title'|translate|lowercase) +', ' +('t-reference'|translate|lowercase) +'...'"
              [formControl]="queryField">
            <i class="ri-search-line search-icon"></i>
          </div>
        </div>
      </div>
      <button
        *ngIf="(loginUser.id===propertyUpdate?.mainAgent) || permissionsService.canEditProperty(loginUser, propertyToPermission?.store?.id) || !propertyUpdate"
        (click)="addBlock(blockContent)" class="btn btn-outline-primary float-end waves-effect waves-primary btn-sm">
        <i class="ri-add-fill me-1 align-bottom"></i>
        {{'t-developments.t-new-block' | translate}}
      </button>
    </div>
    <div class="blocks mt-3">
      <ngx-simplebar class="mx-n4 px-4" style="max-height: calc(100vh - 340px);">
        <div *ngIf="dataBlocks && dataBlocks.length > 0 && (!noBlockFractions || noBlockFractions?.length === 0)"
          class="accordion custom-accordionwithicon custom-accordion-border accordion-border-box accordion-primary"
          id="accordionBordered">
          <div class="accordion-item mb-2" *ngFor="let block of dataBlocks;">

            <h2 class="accordion-header" id="accordionborderedExample{{block.id}}">
              <button (click)="openOrCloseDropdown(block)" class="accordion-button collapsed" type="button"
                data-bs-toggle="collapse" attr.data-bs-target="#accor_borderedExamplecollapse{{block.id}}"
                aria-expanded="false" attr.aria-controls="accor_borderedExamplecollapse{{block.id}}">
                <div class="align-items-center w-100 d-flex justify-content-between">
                  <h5 class="mb-0">{{block.name}}</h5>
                  <div
                    *ngIf="(loginUser.id===propertyUpdate?.mainAgent) || permissionsService.canEditProperty(loginUser, propertyToPermission?.store?.id) || !propertyUpdate"
                    class="me-4">
                    <span class="me-2 btn btn-sm btn-soft-danger" (click)="deleteBlock(block)"><i
                        class="ri-delete-bin-2-line"></i></span>
                    <span (click)="addFraction(fractionContent, block.id)"
                      class="btn btn-outline-primary float-end waves-effect waves-primary btn-sm">
                      <i class="ri-add-fill me-1 align-bottom"></i>
                      {{'t-developments.t-add-unit-to-block' | translate}}
                    </span>
                  </div>
                </div>
              </button>

            </h2>
            <div id="accor_borderedExamplecollapse{{block.id}}" class="accordion-collapse collapse"
              attr.aria-labelledby="accordionborderedExample{{block.id}}" data-bs-parent="#accordionBordered">
              <div class="accordion-body p-0">
                <div class="card-body py-0">
                  <ngx-simplebar class="mx-n4 px-4" style="max-height: 290px;">
                    <div class="table-card gridjs-border-none mt-0">
                      <div class="table-responsive overflow-visible" *ngIf="block.units && block.units.length>0">

                        <table class="table align-middle">
                          <thead>
                            <tr class="bg-light text-muted sticky-table">
                              <th scope="col" class="cursor-pointer" (click)="onUnitsSort('reference', block)">
                                {{ 't-m-properties.t-property'| translate }}
                                <span class="ms-1">{{ getUnitsSortIndicator('reference') }}</span>
                              </th>
                              <!-- <th scope="col">{{ 't-m-properties.t-reference'| translate }}</th> -->
                              <th scope="col" class="cursor-pointer" (click)="onUnitsSort('floor', block)">
                                {{ 't-m-properties.t-floor'| translate }}
                                <span class="ms-1">{{ getUnitsSortIndicator('floor') }}</span>
                              </th>
                              <!-- <th scope="col">Fração</th> -->
                              <th scope="col">{{ 't-m-properties.t-property-type'| translate }}
                              </th>
                              <th scope="col" class="cursor-pointer" (click)="onUnitsSort('price', block)">
                                {{ 't-m-properties.t-price'| translate }}
                                <span class="ms-1">{{ getUnitsSortIndicator('price') }}</span>
                              </th>
                              <th scope="col" class="align-middle cursor-pointer" (click)="onUnitsSort('grossArea', block)">
                                <i class="fs-18 las la-ruler-combined"></i>
                                <span class="ms-1">{{ getUnitsSortIndicator('grossArea') }}</span>
                              </th>
                              <th scope="col" class="align-middle cursor-pointer" (click)="onUnitsSort('bedrooms', block)">
                                <i class="fs-18 la-bed las"></i>
                                <span class="ms-1">{{ getUnitsSortIndicator('bedrooms') }}</span>
                              </th>
                              <th scope="col" class="align-middle cursor-pointer" (click)="onUnitsSort('bathrooms', block)">
                                <i class="fs-18 las la-bath"></i>
                                <span class="ms-1">{{ getUnitsSortIndicator('bathrooms') }}</span>
                              </th>
                              <th scope="col">{{ 't-m-properties.t-status'| translate }}</th>
                              <th
                                *ngIf="(loginUser.id===propertyUpdate?.mainAgent) || permissionsService.canEditProperty(loginUser, propertyToPermission?.store?.id) || !propertyUpdate"
                                scope="col">{{ 't-developments.t-block'|
                                translate }}</th>
                              <th scope="col">{{'t-action' | translate}}</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr *ngFor="let property of unitsToShow">
                              <td>
                                <span>
                                  <div class="d-flex align-items-center">
                                    <div class="flex-grow-1">
                                      <span class="fs-13 mb-1">
                                        {{property.title[0].text}}
                                      </span>
                                      <p *ngIf="property?.reference && !property?.isNew" class="mb-0">
                                        {{ 't-m-properties.t-reference'| translate }} :
                                        <span class="fs-12">
                                          {{property.reference}}
                                        </span>
                                      </p>
                                    </div>
                                  </div>
                                </span>
                              </td>
                              <!-- <td (click)="openModal(property)" class="cursor-pointer">{{property.reference}}</td> -->
                              <!-- Piso, tipo, preço, área, quartos e WC: células editáveis com um clique -->
                              <ng-container *ngTemplateOutlet="inlineCells; context: { unit: property, block: block }"></ng-container>
                              <td class="status">
                                <span class="badge text-uppercase"
                                  [class.cursor-pointer]="canToggleFractionStatus(property)"
                                  [ngbTooltip]="canToggleFractionStatus(property) ? ((property?.status ? 't-m-properties.t-inactive' : 't-m-properties.t-active') | translate) : null"
                                  container="body" placement="top" (click)="toggleFractionStatus(property)"
                                  [ngClass]="{'badge-soft-success':property?.status && !property?.isNew ,'badge-soft-danger':!property?.status && !property?.isNew, 'badge-soft-info': property?.isNew}">
                                  <!-- {{property?.status?'Active':'Inactive'}} -->
                                  <ng-container *ngIf="property?.status && !property?.isNew">
                                    {{ 't-m-properties.t-active'| translate }}
                                  </ng-container>
                                  <ng-container *ngIf="!property?.status && !property?.isNew">
                                    {{ 't-m-properties.t-inactive'| translate }}
                                  </ng-container>
                                  <ng-container *ngIf="property?.isNew">
                                    {{ 't-new'| translate }}
                                  </ng-container>
                                </span>
                              </td>
                              <td
                                *ngIf="(loginUser.id===propertyUpdate?.mainAgent) || permissionsService.canEditProperty(loginUser, propertyToPermission?.store?.id) || !propertyUpdate">
                                <select class="form-select form-select-sm" aria-label=".form-select-sm example"
                                  (change)="onChangeBlock($event, property, block)">
                                  <option [attr.selected]="blocks?.id === block?.id?true:null"
                                    *ngFor="let blocks of dataBlocks; let j=index" [value]="blocks.id">
                                    {{blocks.name}}
                                  </option>
                                </select>
                              </td>
                              <td>
                                <ul class="list-inline hstack gap-2 mb-0">
                                  <li class="list-inline-item" ngbTooltip="{{'t-view' | translate}}" placement="top"
                                    container="body"
                                    *ngIf="(loginUser.id!==propertyUpdate?.mainAgent &&  loginUser.id!==property?.mainAgent) && !permissionsService.canEditProperty(loginUser, propertyToPermission?.store?.id)">
                                    <a class="edit-item-btn cursor-pointer text-primary" (click)="viewFraction(property)"><i
                                        class="ri-eye-line align-bottom  fs-16"></i></a>
                                  </li>
                                  <li
                                    *ngIf="canManageUnit(property)"
                                    ngbTooltip="{{'t-edit' | translate}}" container="body" placement="top"
                                    class="list-inline-item">
                                    <a (click)="editFraction(property, fractionContent)"
                                      class="edit-item-btn cursor-pointer text-primary"><i
                                        class="ri-pencil-fill align-bottom  fs-16"></i></a>
                                  </li>
                                  <ng-container *appHasPermission="'CREATE_PROPERTIES'">
                                    <li *ngIf="canManageUnit(property)" ngbTooltip="{{'t-duplicate' | translate}}"
                                      container="body" placement="top" class="list-inline-item">
                                      <a (click)="duplicateFraction(property, block.id)"
                                        class="edit-item-btn cursor-pointer text-secondary">
                                        <i class="align-bottom fs-16"
                                          [ngClass]="property?.isDuplicating ? 'ri-loader-4-line spin' : 'ri-file-copy-line'"></i>
                                      </a>
                                    </li>
                                    <!-- "Criar revenda": imóvel comum a partir da fração (só gravadas). -->
                                    <li *ngIf="canManageUnit(property) && !property.isNew"
                                      ngbTooltip="{{'t-create-resale' | translate}}" container="body" placement="top"
                                      class="list-inline-item">
                                      <a (click)="createResale(property)"
                                        class="edit-item-btn cursor-pointer text-secondary">
                                        <i class="align-bottom fs-16"
                                          [ngClass]="property?.isCreatingResale ? 'ri-loader-4-line spin' : 'ri-exchange-line'"></i>
                                      </a>
                                    </li>
                                  </ng-container>
                                  <ng-container>
                                    <li
                                      *ngIf="canManageUnit(property)"
                                      ngbTooltip="{{'t-delete' | translate}}" container="body" placement="top"
                                      class="list-inline-item">
                                      <a (click)="deleteFraction(property, block.id)"
                                        class="remove-item-btn cursor-pointer text-danger">
                                        <i class="ri-delete-bin-fill align-bottom"></i>
                                      </a>
                                    </li>
                                  </ng-container>
                                </ul>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <div class="mb-4 me-0 mt-0 row" *ngIf="block.units && block.units!.length>0">
                          <!-- Pagination -->
                          <div class="col">
                            <div class="listjs-pagination">
                              <ngb-pagination [maxSize]="4" [collectionSize]="(block.units!.length)"
                                [page]="getBlockPage(block)" [pageSize]="pageSize"
                                (pageChange)="onBlockPageChange(block, $event)">
                              </ngb-pagination>
                            </div>
                          </div>
                          <!-- End Pagination -->
                        </div>
                      </div>
                      <div *ngIf="!block.units || block.units.length === 0">
                        <div class="py-4 text-center">
                          <div>
                            <lord-icon src="https://cdn.lordicon.com/msoeawqm.json" trigger="loop"
                              colors="primary:#405189,secondary:#0ab39c" style="width:72px;height:72px">
                            </lord-icon>
                          </div>
                          <div class="mt-4">
                            <h5>{{'t-developments.t-no-one-unit-block' | translate}}</h5>
                          </div>
                        </div>
                      </div>
                    </div>
                  </ngx-simplebar>
                </div>
              </div>
            </div>
          </div>

        </div>
      </ngx-simplebar>
    </div>
  </div>
</div>

<!-- Modal -->
<ng-template #blockContent role="document" let-modal>
  <div class="modal-header p-3 ps-4 bg-soft-primary">
    <h5 class="modal-title" id="inviteMembersModalLabel">
      {{'t-developments.t-new-block' | translate}}
    </h5>
    <button type="button" id="block-dismiss-btn" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
      (click)="modal.dismiss('Cross click')"></button>
  </div>
  <div class="modal-body p-4">
    <form [formGroup]="blockForm">
      <div class="row">
        <div class="col-md-12 mb-3">
          <label class="form-label">{{'t-name' | translate}}</label>
          <input type="text" class="form-control" [ngClass]="{ 'is-invalid': submited && formBlock['name'].errors }"
            id="priceInput" placeholder="{{'t-name' | translate}}" formControlName="name">
          <div *ngIf="submited && formBlock['name'].errors" class="invalid-feedback" align="left">
            <span *ngIf="formBlock['name'].errors['required']">{{'t-name-error-required' | translate}}</span>
            <span *ngIf="formBlock['name'].errors['nameExists']">{{'t-developments.t-name-exists' | translate}}</span>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-light w-xs" data-bs-dismiss="modal"
      (click)="clearFormBlock(); modal.close('')">{{'t-proposals.t-cancel' | translate}}</button>
    <button type="button" class="btn btn-primary w-xs" (click)="submitNewBlock()">
      {{'t-save' | translate}}
    </button>
  </div>
</ng-template>

<!-- Modal -->
<ng-template #fractionContent role="document" let-modal>
  <div class="modal-header p-3 ps-4 bg-soft-primary">
    <h5 class="modal-title" id="inviteMembersModalLabel">
      {{fractionUpdated ? ('t-developments.t-edit-fraction' | translate) : ('t-developments.t-new-fraction' |
      translate)}}
    </h5>
    <button type="button" id="block-dismiss-btn" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
      (click)="modal.dismiss('Cross click')"></button>
  </div>
  <div class="modal-body p-4">
    <form [formGroup]="fractionForm">
      <div class="row">
        <div *ngIf="!fractionUpdated" class="col-md-6 mb-3">
          <label class="form-label">{{ 't-m-properties.t-number-of-units' | translate }}</label>
          <ng-select [items]="fractionQuantity" [multiple]="false"
            placeholder="{{ 't-m-properties.t-number-of-units' | translate }}" formControlName="quantity"
            [clearable]="false">
          </ng-select>
        </div>
        <div class="col-md-6 mb-3">
          <label class="form-label">{{ 't-property-type' | translate }}</label>
          <ng-select [items]="propertyTypes" [multiple]="false" bindLabel="description" bindValue="id"
            placeholder="{{'t-property-type' | translate }}" required formControlName="propertyType" [clearable]="false"
            [ngClass]="{ 'is-invalid': submited && formFraction['propertyType'].errors && formFraction['propertyType'].errors['required'] }"
            groupBy="groupDescription" class="details-propertytype">
            <ng-template ng-optgroup-tmp let-item="item">
              {{item.groupDescription==='---'?'N/A':item.groupDescription || 'Unnamed group'}}
            </ng-template>
          </ng-select>
          <div *ngIf="submited && formFraction['propertyType'].errors" class="invalid-feedback" align="left">
            {{'t-developments.t-property-type-error-required' | translate}}
          </div>
        </div>
        <div class="col-md-6 mb-3">
          <label class="form-label">{{'t-price' | translate}}</label>
          <input type="text" class="form-control" mask="separator" thousandSeparator=" "
            placeholder="{{'t-price' | translate}}" formControlName="price">
        </div>
        <div class="col-md-6 mb-3">
          <label class="form-label">{{'t-m-properties.t-floor' | translate}}</label>
          <input type="number" class="form-control" placeholder="{{'t-m-properties.t-floor' | translate}}"
            formControlName="floor">
        </div>
        <div class="col-md-4">
          <label class="form-label">{{'t-m-properties.t-gross-area' | translate}}</label>
          <input type="number" class="form-control" placeholder="{{'t-m-properties.t-gross-area' | translate}}"
            formControlName="grossArea">
        </div>
        <div class="col-md-4">
          <label class="form-label w-100">{{'t-mls-filters.t-bedrooms' | translate}}</label>
          <div class="input-step w-100">
            <button type="button" class="minus" (click)="decrement('bedrooms')">–</button>
            <input type="number" class="product-quantity w-100" min="0" max="20" readonly formControlName="bedrooms">
            <button type="button" class="plus" (click)="increment('bedrooms')">+</button>
          </div>
        </div>
        <div class="col-md-4">
          <label class="form-label w-100">{{'t-mls-filters.t-bathrooms' | translate}}</label>
          <div class="input-step w-100">
            <button type="button" class="minus" (click)="decrement('bathrooms')">–</button>
            <input type="number" class="product-quantity w-100" min="0" max="20" readonly formControlName="bathrooms">
            <button type="button" class="plus" (click)="increment('bathrooms')">+</button>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-light w-xs" data-bs-dismiss="modal"
      (click)="clearFormFraction(); modal.close('')">{{'t-proposals.t-cancel' | translate}}</button>
    <button type="button" class="btn btn-primary w-xs" (click)="submitNewFraction()">
      {{'t-save' | translate}}
    </button>
  </div>
</ng-template>

<!-- Células editáveis da lista de frações (piso, tipo, preço, área, quartos, WC).
     Um clique abre o editor no lugar; Enter/blur grava, Esc cancela. Frações já
     gravadas vão ao servidor (PATCH units/:id/basic); as novas ficam em memória
     até se gravar o empreendimento. -->
<ng-template #inlineCells let-unit="unit" let-block="block">
  <!-- Piso -->
  <td class="unit-inline-cell" [class.unit-inline-editable]="canInlineEdit(unit) && !isInlineEditing(unit, 'floor')"
    (click)="startInlineEdit(unit, 'floor', $event)">
    <ng-container *ngIf="!isInlineEditing(unit, 'floor'); else floorEditor">
      <p class="mb-0 unit-inline-value">{{ unit?.floor }}</p>
    </ng-container>
    <ng-template #floorEditor>
      <input [id]="inlineEditorId(unit, 'floor')" type="text" class="form-control form-control-sm unit-inline-input"
        [(ngModel)]="inlineEditValue" [ngModelOptions]="{ standalone: true }" [disabled]="inlineSaving"
        (keydown)="onInlineKeydown($event, unit, block)" (blur)="commitInlineEdit(unit, block)"
        (click)="$event.stopPropagation()" />
    </ng-template>
  </td>
  <!-- Tipo de imóvel -->
  <td class="w-xs unit-inline-cell" [class.unit-inline-editable]="canInlineEdit(unit) && !isInlineEditing(unit, 'propertyType')"
    (click)="startInlineEdit(unit, 'propertyType', $event)">
    <ng-container *ngIf="!isInlineEditing(unit, 'propertyType'); else typeEditor">
      <span class="unit-inline-value">{{ unit?.propertyType }}</span>
    </ng-container>
    <ng-template #typeEditor>
      <ng-select [id]="inlineEditorId(unit, 'propertyType')" [items]="propertyTypes" bindLabel="description" bindValue="id"
        groupBy="groupDescription" [clearable]="false" [disabled]="inlineSaving" class="unit-inline-select"
        placeholder="{{ 't-property-type' | translate }}" [(ngModel)]="inlineEditValue"
        [ngModelOptions]="{ standalone: true }" (change)="commitInlineEdit(unit, block)"
        (close)="commitInlineEdit(unit, block)" (click)="$event.stopPropagation()">
        <ng-template ng-optgroup-tmp let-item="item">
          {{ item.groupDescription === '---' ? 'N/A' : item.groupDescription || 'Unnamed group' }}
        </ng-template>
      </ng-select>
    </ng-template>
  </td>
  <!-- Preço -->
  <td class="w-xs unit-inline-cell" [class.unit-inline-editable]="canInlineEdit(unit) && !isInlineEditing(unit, 'price')"
    (click)="startInlineEdit(unit, 'price', $event)">
    <ng-container *ngIf="!isInlineEditing(unit, 'price'); else priceEditor">
      <span class="unit-inline-value">{{ priceFormat(unit?.price) }}</span>
    </ng-container>
    <ng-template #priceEditor>
      <input [id]="inlineEditorId(unit, 'price')" type="text" mask="separator" thousandSeparator=" "
        class="form-control form-control-sm unit-inline-input" [(ngModel)]="inlineEditValue"
        [ngModelOptions]="{ standalone: true }" [disabled]="inlineSaving"
        (keydown)="onInlineKeydown($event, unit, block)" (blur)="commitInlineEdit(unit, block)"
        (click)="$event.stopPropagation()" />
    </ng-template>
  </td>
  <!-- Área bruta -->
  <td class="unit-inline-cell" [class.unit-inline-editable]="canInlineEdit(unit) && !isInlineEditing(unit, 'grossArea')"
    (click)="startInlineEdit(unit, 'grossArea', $event)">
    <ng-container *ngIf="!isInlineEditing(unit, 'grossArea'); else areaEditor">
      <span class="unit-inline-value">{{ unit?.grossArea ? unit?.grossArea + ' m²' : '' }}</span>
    </ng-container>
    <ng-template #areaEditor>
      <input [id]="inlineEditorId(unit, 'grossArea')" type="text" mask="separator" thousandSeparator=" "
        class="form-control form-control-sm unit-inline-input" [(ngModel)]="inlineEditValue"
        [ngModelOptions]="{ standalone: true }" [disabled]="inlineSaving"
        (keydown)="onInlineKeydown($event, unit, block)" (blur)="commitInlineEdit(unit, block)"
        (click)="$event.stopPropagation()" />
    </ng-template>
  </td>
  <!-- Quartos -->
  <td class="unit-inline-cell" [class.unit-inline-editable]="canInlineEdit(unit) && !isInlineEditing(unit, 'bedrooms')"
    (click)="startInlineEdit(unit, 'bedrooms', $event)">
    <ng-container *ngIf="!isInlineEditing(unit, 'bedrooms'); else bedroomsEditor">
      <span class="unit-inline-value">{{ unit?.bedrooms ? unit?.bedrooms : 0 }}</span>
    </ng-container>
    <ng-template #bedroomsEditor>
      <input [id]="inlineEditorId(unit, 'bedrooms')" type="number" min="0" step="1"
        class="form-control form-control-sm unit-inline-input unit-inline-input-narrow" [(ngModel)]="inlineEditValue"
        [ngModelOptions]="{ standalone: true }" [disabled]="inlineSaving"
        (keydown)="onInlineKeydown($event, unit, block)" (blur)="commitInlineEdit(unit, block)"
        (click)="$event.stopPropagation()" />
    </ng-template>
  </td>
  <!-- WC -->
  <td class="unit-inline-cell" [class.unit-inline-editable]="canInlineEdit(unit) && !isInlineEditing(unit, 'bathrooms')"
    (click)="startInlineEdit(unit, 'bathrooms', $event)">
    <ng-container *ngIf="!isInlineEditing(unit, 'bathrooms'); else bathroomsEditor">
      <span class="unit-inline-value">{{ unit?.bathrooms ? unit?.bathrooms : 0 }}</span>
    </ng-container>
    <ng-template #bathroomsEditor>
      <input [id]="inlineEditorId(unit, 'bathrooms')" type="number" min="0" step="1"
        class="form-control form-control-sm unit-inline-input unit-inline-input-narrow" [(ngModel)]="inlineEditValue"
        [ngModelOptions]="{ standalone: true }" [disabled]="inlineSaving"
        (keydown)="onInlineKeydown($event, unit, block)" (blur)="commitInlineEdit(unit, block)"
        (click)="$event.stopPropagation()" />
    </ng-template>
  </td>
</ng-template>
